import { BaseDisplayer } from './BaseDisplayer';
import { ValueType } from '../FormatterTypes';
import { formatterStrParam } from '../Utils/ParamUtils';
import { asString } from '../Utils/ValueUtils';

class TEDDisplayOrgNrPersNr extends BaseDisplayer {
  public static getInstance(): TEDDisplayOrgNrPersNr {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDDisplayOrgNrPersNr;

  defaultParams(): string {
    return `Sep="-"`;
  }

  defaultDisplayLength(): number {
    return 13;
  }

  display(
    value: ValueType,
    displayText: boolean = true,
    params: string = ''
  ): string {
    let valAsStr: string = asString(value) || '';

    const allDigits: boolean = valAsStr
      .split('')
      .every(d => !isNaN(parseInt(d, 10)));
    const { value: sep, result: haveSep } = formatterStrParam(
      'Sep',
      params,
      this.defaultParams()
    );

    if ([10, 11, 12].includes(valAsStr.length) && allDigits && haveSep) {
      if (valAsStr.length === 10) {
        valAsStr = valAsStr.slice(0, 6) + sep + valAsStr.slice(6);
      } else {
        valAsStr = valAsStr.slice(0, 8) + sep + valAsStr.slice(8);
      }
    }

    return valAsStr;
  }
}

export { TEDDisplayOrgNrPersNr };
